import axiosService from "@/services/axios-service";
import RESTApiEndPoints from "@/services/rest-api-end-points";
import IWasteBulkRecord from "@/models/waste-bulk-record";
import { EpmdTypeEnum } from "@/models/EpmdTypeEnum";

export default class WasteBulkRecordsService {
  public async GetWasteBulkRecord(id: number) {
    return axiosService.get<IWasteBulkRecord>(`${RESTApiEndPoints.wasteBulkRecordUrl()}/${id}`);
  }

  public async FindWasteBulkRecord(epmdType: EpmdTypeEnum, date: Date, shipId: number) {
    return axiosService.post<IWasteBulkRecord | null>(
      `${RESTApiEndPoints.wasteBulkRecordUrl()}/find/${epmdType}`,
      {
        date,
        shipId
      }
    );
  }

  public async PostWasteBulkRecord(wasteBulkRecord: IWasteBulkRecord) {
    return axiosService.post<IWasteBulkRecord>(
      RESTApiEndPoints.wasteBulkRecordUrl(),
      wasteBulkRecord
    );
  }

  // public async PutWasteBulkRecord(
  //   id: number,
  //   wasteBulkRecord: IWasteBulkRecord
  // ) {
  //   return axiosService.put<IWasteBulkRecord>(
  //     `${RESTApiEndPoints.wasteBulkRecordUrl()}/${id}`,
  //     wasteBulkRecord
  //   );
  // }
  public async DeleteWasteBulkRecord(id: string) {
    return axiosService.delete<IWasteBulkRecord>(`${RESTApiEndPoints.wasteBulkRecordUrl()}/${id}`);
  }
}
